export default "__VITE_ASSET__DAQmq0_X__"